import type { Segment, SegmentsClientInterface } from './segmentsClient.types';
import BaseClient from '../BaseClient';
import type { QueryParams } from '~/services/api';

export default class CorporateSegmentsClient extends BaseClient implements SegmentsClientInterface {
    constructor(private teamId: number) {
        super();
    }

    getSegments(params?: QueryParams) {
        const url = `/api/v3/teams/${this.teamId}/segments`;
        return this.makeCoreApiRequest(url, 'get', null, params);
    }

    getSegmentsCount(params?: QueryParams) {
        const url = `/api/v3/teams/${this.teamId}/segments/count`;
        return this.makeCoreApiRequest(url, 'get', null, params);
    }

    createSegment(segment: Segment) {
        const url = `/api/v3/teams/${this.teamId}/segments`;
        return this.makeCoreApiRequest(url, 'post', segment);
    }

    updateSegment(segmentId: number, segment: Segment) {
        const url = `/api/v3/teams/${this.teamId}/segments/${segmentId}`;
        return this.makeCoreApiRequest(url, 'put', segment);
    }

    deleteSegment(segmentId: number) {
        const url = `/api/v3/teams/${this.teamId}/segments/${segmentId}`;
        return this.makeCoreApiRequest(url, 'delete');
    }

    getSegment(segmentId: number) {
        const url = `/api/v3/teams/${this.teamId}/segments/${segmentId}`;
        return this.makeCoreApiRequest(url, 'get');
    }

    getSegmentContacts(segmentId: number, params?: QueryParams) {
        const url = `/api/v3/teams/${this.teamId}/segments/${segmentId}/contacts`;
        return this.makeCoreApiRequest(url, 'get', null, params);
    }

    refreshSegment(segmentId: number) {
        const url = `/api/v3/teams/${this.teamId}/segments/${segmentId}/refresh`;
        return this.makeCoreApiRequest(url, 'post');
    }

    getSegmentsContactsCount(params?: QueryParams) {
        const url = `/api/v3/teams/${this.teamId}/segments/contact-counts`;
        return this.makeCoreApiRequest(url, 'get', null, params);
    }

    getSegmentsGroupCounts(params?: QueryParams) {
        const url = `/api/v3/teams/${this.teamId}/segments/group-counts`;
        return this.makeCoreApiRequest(url, 'get', null, params);
    }

    dependencies(segmentId: number) {
        const url = `/api/v3/teams/${this.teamId}/segments/${segmentId}/dependencies`;
        return this.makeCoreApiRequest(url, 'get');
    }

    getSegmentStatus(segmentId: number) {
        const url = `/api/v3/teams/${this.teamId}/segments/${segmentId}/status`;
        return this.makeCoreApiRequest(url, 'get');
    }

    tagContacts(segmentId: number, data: { tags: string[] }) {
        const url = `/api/v3/teams/${this.teamId}/segments/${segmentId}/tag`;
        return this.makeCoreApiRequest(url, 'post', data);
    }

    countByAudienceType() {
        const url = `/api/v3/teams/${this.teamId}/segments/count/audience-type`;
        return this.makeCoreApiRequest(url, 'get');
    }

    countByRefreshType() {
        const url = `/api/v3/teams/${this.teamId}/segments/count/refresh-type`;
        return this.makeCoreApiRequest(url, 'get');
    }
}
